import React from 'react';

import { WarningMessage } from '@eika/attention-message';
import { ErrorCard } from '@eika/card';
import { CheckmarkAnimation } from '@eika/checkmark-animation';
import { IconTypes } from '@eika/icon';

import { BlockReorderLoader, Piwik, SiteCoreDictionary } from '../types';

import './SuccessReceipt.scss';

interface ReceiptProps {
    blockReorderLoader: BlockReorderLoader;
    wishToOrderNewCard: boolean;
    showShipmentInfo?: boolean;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const Receipt = ({ blockReorderLoader, wishToOrderNewCard, dictionary, showShipmentInfo, piwik }: ReceiptProps) => {
    const {
        blockStatusReordered,
        orderBankCardFailureText,
        messageErrorUps,
        noOrderBankCardSuccessText,
        orderCardStep0Description,
        orderCardErrorBlockCardSuccess,
    } = dictionary;
    const { failedHardBlockingCard, failedReorderingCard } = blockReorderLoader;

    if (failedHardBlockingCard) {
        return (
            <ErrorCard
                data-track-id={piwik?.blockCardForm?.hardBlockCardError?.dataTrackId}
                data-track-linkname={piwik?.blockCardForm?.hardBlockCardError?.dataTrackLinkname}
                id={piwik?.blockCardForm?.hardBlockCardError?.dataTrackId}
                description={orderBankCardFailureText}
                title={messageErrorUps}
            />
        );
    }

    return (
        <div
            className="receipt-container"
            data-track-id={piwik?.orderNewCardForm?.orderCardSuccess?.dataTrackId}
            data-track-linkname={piwik?.orderNewCardForm?.orderCardSuccess?.dataTrackLinkname}
            id={piwik?.orderNewCardForm?.orderCardSuccess?.dataTrackId}
        >
            <div className="checkmark-container">
                <CheckmarkAnimation />
            </div>
            <div className="card-ordered">
                {wishToOrderNewCard && !failedReorderingCard ? blockStatusReordered : noOrderBankCardSuccessText}
            </div>
            {showShipmentInfo && !failedReorderingCard && <p>{orderCardStep0Description}</p>}
            {failedReorderingCard && (
                <WarningMessage
                    className="error-card-not-reordered"
                    text={
                        <>
                            <p>{orderCardErrorBlockCardSuccess}</p>
                        </>
                    }
                    icon={IconTypes.LUKK_24}
                />
            )}
        </div>
    );
};

export default Receipt;
